// extracted by mini-css-extract-plugin
export default {"root":"_3_a1i","small":"_3rMGI","normal":"_3mfwZ"};